module.exports = __webpack_public_path__ + "img/Transparent.65d8845b.png";